/** The sign-in screens' modes, wording, and which one opens first. */

export type Mode = 'SIGN_IN' | 'CODE' | 'FORGOT' | 'RESET';

export function tokenFromUrl(): string {
  return new URLSearchParams(window.location.search).get('token') ?? '';
}

export function firstMode(resetToken: string, challenge: string): Mode {
  if (resetToken) return 'RESET';
  return challenge ? 'CODE' : 'SIGN_IN';
}

export const COPY: Record<Mode, { title: string; blurb: string }> = {
  SIGN_IN: { title: 'Welcome back', blurb: 'Sign in to your SynAnalytics workspace.' },
  CODE: {
    title: 'Two-step verification',
    blurb: 'Enter the 6-digit code from your authenticator app.',
  },
  FORGOT: {
    title: 'Forgot your password',
    blurb: 'Enter your email and we will send you a reset link.',
  },
  RESET: {
    title: 'Set a new password',
    blurb: 'Paste the token from your email, then choose a new password.',
  },
};
